export const GET_STATES = 'https://countriesnow.space/api/v0.1/countries/states/q?country=United States';